import { api } from '../api/client.js';
import { createTabBar } from '../components/tab-bar.js';
import { createSkeleton } from '../components/skeleton.js';
import { getRouter } from '../router.js';
import {
  createContactGroupSection,
  renderContactTags,
  createTagChips,
  type ContactData,
  type ContactGroupData,
} from '../components/contact-card.js';

interface ContactsResponse {
  groups: ContactGroupData[];
  contacts: ContactData[];
}

export async function contactsPage(): Promise<HTMLElement> {
  const router = getRouter();
  const page = document.createElement('div');
  page.className = 'page page--contacts';
  page.setAttribute('data-title', 'Контакты');

  // Header
  const header = document.createElement('header');
  header.className = 'page-header';
  header.innerHTML = `
  <svg class="page-header__logo" width="32" height="28" viewBox="0 0 32 28" fill="none" aria-hidden="true">
    <polyline points="2,14 16,2 30,14" stroke="#4a7c2f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    <rect x="6" y="14" width="20" height="12" rx="1" stroke="#4a7c2f" stroke-width="1.5" fill="none"/>
    <rect x="13" y="19" width="6" height="7" rx="1" stroke="#4a7c2f" stroke-width="1.5" fill="none"/>
  </svg>
  <div class="page-header__text">
    <h1 class="page-header__title">СНТ "ЭЛЕКТРОН"</h1>
    <span class="page-header__subtitle">Садовое некоммерческое товарищество</span>
  </div>`;
  page.appendChild(header);

  // Tabs
  const featureListings = import.meta.env.VITE_FEATURE_LISTINGS === 'true';
  const tabs = createTabBar([
    { id: 'news', label: 'Новости', href: '/' },
    { id: 'contacts', label: 'Контакты', href: '/contacts' },
    { id: 'board', label: 'Объявления', href: '/board', hidden: !featureListings },
    { id: 'bus', label: 'Автобус', href: '/bus' },
  ], 'contacts', (href) => router.navigate(href));
  page.appendChild(tabs);

  // Content
  const content = document.createElement('div');
  content.className = 'page-content';

  const skeleton = createSkeleton('card', 2);
  content.appendChild(skeleton);
  page.appendChild(content);

  try {
    const data = await api.get<ContactsResponse>('/contacts');
    content.innerHTML = '';

    // Filter state
    let activeTag: string | null = null;

    // Tags
    const allTags = renderContactTags(data.contacts);
    const tagsContainer = createTagChips(allTags, activeTag, (tag) => {
      activeTag = tag;
      renderGroups(data, content, activeTag);
    });
    tagsContainer.className = 'contact-tags';
    content.appendChild(tagsContainer);

    // Groups container
    const groupsContainer = document.createElement('div');
    groupsContainer.className = 'contact-groups';
    content.appendChild(groupsContainer);

    function renderGroups(data: ContactsResponse, container: HTMLElement, tag: string | null): void {
      const gc = container.querySelector('.contact-groups');
      if (!gc) return;
      gc.innerHTML = '';
      for (const group of data.groups) {
        const section = createContactGroupSection(
          group,
          data.contacts.filter(c => c.groupId === group.id),
          tag,
        );
        if (section) {
          gc.appendChild(section);
        }
      }
    }

    renderGroups(data, content, null);
  } catch (err) {
    content.innerHTML = '';
    const error = document.createElement('div');
    error.className = 'empty-state';
    error.innerHTML = '<p>Ошибка загрузки контактов</p>';
    content.appendChild(error);
    console.error(err);
  }

  return page;
}
